import { spawn } from 'redux-saga/effects';
import keySagas from './key/keySagas';

export default function* sagas() {
	yield spawn(keySagas);
}
